import { z } from 'zod';

/////////////////////////////////////////
// CORE PICKLIST ITEM SCHEMA
/////////////////////////////////////////

export const CorePicklistItemSchema = z.object({
  id: z.number().int(),
  value: z.string(),
  order: z.number().int(),
  picklistId: z.number().int(),
  deactivatedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  rowTimestamp: z.coerce.date(),
})

export type CorePicklistItem = z.infer<typeof CorePicklistItemSchema>

export default CorePicklistItemSchema;
